export const getFormattedToUTCDate = (date?: string): string =>
  date
    ? new Date(date).toLocaleDateString("en-US", {
        timeZone: "UTC",
      })
    : "";
